import "./Balance.scss";
const Balance = (props) => {
  const handleBarcodeBalance = (e) => {
    if (e.key === "Enter") {
      let val = e.target.value;
      e.target.value="";
      props.onCheckBarcode(val);
    }
  };
  return (
    <div className="balance">
      <h6>تراز فاکتور</h6>
      <input
        type="text"
        className="form-control"
        placeholder=" بارکد را وارد کنید"
        name="balance-barcode"
        onKeyUp={handleBarcodeBalance}
      />
      <p className="remain"></p>
    </div>
  );
};
export default Balance;
